export const UPSERT_ENG_PAYMENT_LIST = "UPSERT_ENG_PAYMENT_LIST"
export const UPSERT_ENG_PAYMENT_LIST_SUCCESS = "UPSERT_ENG_PAYMENT_LIST_SUCCESS"
export const UPSERT_ENG_PAYMENT_LIST_FAIL = "UPSERT_ENG_PAYMENT_LIST_FAIL"

export const GET_ENG_PAYMENT_LIST = "GET_ENG_PAYMENT_LIST"
export const GET_ENG_PAYMENT_LIST_SUCCESS = "GET_ENG_PAYMENT_LIST_SUCCESS"
export const GET_ENG_PAYMENT_LIST_FAIL = "GET_ENG_PAYMENT_LIST_FAIL"

export const GET_ENG_PAYMENT_TASK = "GET_ENG_PAYMENT_TASK"
export const GET_ENG_PAYMENT_TASK_SUCCESS = "GET_ENG_PAYMENT_TASK_SUCCESS"
export const GET_ENG_PAYMENT_TASK_FAIL = "GET_ENG_PAYMENT_TASK_FAIL"

export const UPDATE_ENG_PAYMENT_LIST = "UPDATE_ENG_PAYMENT_LIST"
export const UPDATE_ENG_PAYMENT_LIST_SUCCESS = "UPDATE_ENG_PAYMENT_LIST_SUCCESS"
export const UPDATE_ENG_PAYMENT_LIST_FAIL = "UPDATE_ENG_PAYMENT_LIST_FAIL"

export const ENG_PAYMENT_APPROVED = "ENG_PAYMENT_APPROVED"
export const ENG_PAYMENT_APPROVED_SUCCESS = "ENG_PAYMENT_APPROVED_SUCCESS"
export const ENG_PAYMENT_APPROVED_FAIL = "ENG_PAYMENT_APPROVED_FAIL"

export const RESET_ENG_PAYMENT_LIST_FLAG = "RESET_ENG_PAYMENT_LIST_FLAG"